import { useCallback, useMemo, useRef, useState } from 'react';

import _ from 'lodash';

import {
  filterSlashCommandCandidates,
  getSlashCommandId,
  getSlashCommandQueryAtStart,
} from '../../TeamChat.utils';

const useChatSlashCommands = () => {
  const [slashRange, setSlashRange] = useState(null);
  const [slashQuery, setSlashQuery] = useState('');
  const [focusedCommandId, setFocusedCommandId] = useState(null);

  const slashSuggestions = useMemo(() => {
    if (_.isNil(slashRange)) {
      return [];
    }

    return filterSlashCommandCandidates({ query: slashQuery });
  }, [slashRange, slashQuery]);

  const prevSlashSuggestionsRef = useRef(slashSuggestions);

  if (prevSlashSuggestionsRef.current !== slashSuggestions) {
    prevSlashSuggestionsRef.current = slashSuggestions;

    if (!slashSuggestions.length && !_.isNil(focusedCommandId)) {
      setFocusedCommandId(null);
    }

    if (slashSuggestions.length) {
      const stillVisible = slashSuggestions.some(
        command => getSlashCommandId(command) === focusedCommandId,
      );

      if (!stillVisible) {
        setFocusedCommandId(getSlashCommandId(slashSuggestions[0]));
      }
    }
  }

  const updateFromCaret = useCallback((value, caret) => {
    const range = getSlashCommandQueryAtStart(value, caret);

    setSlashRange(range);
    setSlashQuery(range?.query ?? '');
  }, []);

  const reset = useCallback(() => {
    setSlashRange(null);
    setSlashQuery('');
  }, []);

  return {
    slashRange,
    slashSuggestions,
    focusedCommandId,
    setFocusedCommandId,
    updateFromCaret,
    reset,
  };
};

export default useChatSlashCommands;
